import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    padding: 16px 24px 24px;
`;
